// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 768px) {
  ._6835j00 {
    width: calc(100% - 20px);
    margin-left: 10px;
    margin-right: 10px;
    padding-left: 0;
    padding-right: 0;
  }
}
@media screen and (min-width: 768px) {
  ._6835j00 {
    max-width: 137px;
    margin-left: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE;IACE,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":["@media screen and (max-width: 768px) {\n  ._6835j00 {\n    width: calc(100% - 20px);\n    margin-left: 10px;\n    margin-right: 10px;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n@media screen and (min-width: 768px) {\n  ._6835j00 {\n    max-width: 137px;\n    margin-left: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
